import React, { ButtonHTMLAttributes, FC } from 'react';

import { cn } from '../../../../utils';
import { ChevronIcon } from '../../icons';
import { Button } from '../index';

import './BackButton.scoped.scss';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {}

const BackButton: FC<Props> = ({ ...props }) => {
  return (
    <Button {...props} className={cn('back-button', props.className)}>
      <ChevronIcon direction="left" color="var(--primary-green-new)" title="Назад" />
    </Button>
  );
};

export default BackButton;
